// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_d0G","field":"styles_field__2qKUv","fieldCol":"styles_fieldCol__3czxJ","diffCol":"styles_diffCol__3X3PT","diff":"styles_diff__2PCbY"};